module.exports = {
  "/": {
    "success": {
      "homepage loaded": [
        "HOME_LOAD"
      ]
    }
  },
  "/code-of-conduct": {
    "success": {
      "code of conduct loaded": [
        "CODE_OF_CONDUCT_LOAD"
      ]
    }
  }
};